export const postcodeValidator = (postcode: string): boolean => postcode.length > 3 && postcode.length <= 30;
